import chat from './en/chat.json';

export const chatResources = {
  en: { chat },
} as const;
